export enum TimeFormat {
  MS = 'ms',
  S = 's',
}
